export const mapEmployees = (employee) => {
  const birthday = new Date(`${employee.birthday}T12:00:00`)
  const formattedBirthday = birthday.toLocaleString('en-us', {
    month: 'long',
    day: 'numeric',
  })

  return { ...employee, formattedBirthday }
}
